














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ToSignup extends Vue {
  @Prop({ required: true })
  /**
   * @see LoginPageProps.signupLink
   */
  readonly signupLink: string

  @Prop({ default: '会員登録はこちら' })
  readonly label: string
}
